import type {CloudFunctionsService, InvokeCallable} from '../types/services'

export const createCloudFunctionsService = (invoke: InvokeCallable): CloudFunctionsService => ({
  createUser: () => invoke('createUser', {}),
  updateSchedule: schedule => invoke('updateSchedule', {schedule}),
  deleteSchedule: scheduleName => invoke('deleteSchedule', {scheduleName}),
  createSession: session => invoke('createSession', {session}),
  deleteSession: sessionId => invoke('deleteSession', {sessionId}),
  createEvent: event => invoke('createEvent', {event}),
  deleteEvent: eventId => invoke('deleteEvent', {eventId}),
  createConnection: connection => invoke('createConnection', {connection}),
  deleteConnection: connectionId => invoke('deleteConnection', {connectionId}),
})
